// extracted by mini-css-extract-plugin
export var configurationSection = "_sn-0";